import { FC, useEffect, useState } from "react"
import './home.css'
import { Fieldset } from 'primereact/fieldset';
import { SlOrganization } from 'react-icons/sl'
import { TbRadioactiveFilled } from 'react-icons/tb'
import { CardKPI } from "./CardKPI/CardKPI";
import { ScenarioModal } from "./ScenarioModal/ScenarioModal";
import { IScenarioType } from "../../models/ScenarioModel";
import { getHomeInfo, getScenarioByPlantId } from "../../services/home-service";
import { ICardHome, IScenariosTable } from "../../models/HomeModel";
import { error } from "../../utils/notifications";
import { Spinner } from "../shared/Spinner/Spinner";
import { catchResponse } from "../../utils/helperFunctions";
import moment from "moment";


export const Home:FC<any> = (props):JSX.Element => {

    const { history } = props

    const [escenariosEstrategicos, setEscenariosEstrategicos] = useState<ICardHome[]>([])

    const [escenariosOperativos, setEscenariosOperativos] = useState<ICardHome[]>([])

    const [errorEscenarios, setErrorEscenarios] = useState<string>("")

    const [loadingEscenarios, setLoadingEscenarios] = useState<boolean>(false)

    const [openScenarioModal, setOpenScenarioModal] = useState<boolean>(false)

    const [selectedScenario, setSelectedScenario] = useState<IScenarioType>({
        id_plant: 0,
        name_plant:"",
        type_scenario: "",
        anio: moment().year()
    })

    const [scenarios, setScenarios] = useState<IScenariosTable[]>([])

    const [flag, setFlag] = useState<boolean>(false)

    const handleOpenScenarioModal = async(id:number, title:string,type:string,anio:number) => {
        try {
            setSelectedScenario({
                id_plant: id,
                name_plant:title,
                type_scenario:type,
                anio: anio
            })
            const res = await getScenarioByPlantId(id)
            
            if(res.status === 200) {
                if(res.data.code === 200) {
                    const { data } = res.data
                    setScenarios(data)
                    setOpenScenarioModal(true)
                }
            }
        } catch(err:any) {
            catchResponse(err)
        }
        
    }

    
    const legendTemplateStrat = (
        <div className="flex align-items-center text-primary">
            <SlOrganization size={20} />
            <span className="font-bold text-lg">Estratégico</span>
        </div>
    );

    const legendTemplateOp = (
        <div className="flex align-items-center text-primary">
            <TbRadioactiveFilled size={20} />
            <span className="font-bold text-lg">Operativo</span>
        </div>
    );


    const fetchHomeInfo = async () => {
        try {
            setLoadingEscenarios(true)
            const res = await getHomeInfo()
            const { status } = res
            if(status === 200) {
                const { code,data } = res.data
                if(code === 200) {
                    
                    setEscenariosEstrategicos(data.filter((d:ICardHome) => d.id_planner === 1).sort((a:any,b:any) => a.id_plant - b.id_plant))
                 
                    setEscenariosOperativos(data.filter((d:ICardHome) => d.id_planner !== 1).sort((a:any,b:any) => a.id_plant - b.id_plant))
                } 
                setLoadingEscenarios(false)
            }

        } catch(err:any) {
            error("Error obteniendo la información")
            setErrorEscenarios("🔥 No se puede mostrar la información en este momento. Por favor, póngase en contacto con el administrador del sistema")
            setLoadingEscenarios(false)
        }
    }

    useEffect(() => {
        fetchHomeInfo()
    },[flag])

    return(
        <div className="home__wrapper">
            {
                escenariosEstrategicos.some((escenario:ICardHome) => escenario.cambio_pendiente)?
                    <span className="change_anio_alert"><i><small>** Hay un cambio de año en espera, se ejecutará de manera nocturna.</small></i></span>
                :
                false
            }
            
            <div>
                <div>
                <Fieldset style={loadingEscenarios? {justifyContent:'center'}: {justifyContent:'space-between'}} legend={legendTemplateStrat}>
                    {
                        loadingEscenarios?
                            <Spinner message={`Obteniendo Escenario Estratégico`}/>
                        :
                            errorEscenarios !== ""?
                                <span className="error__message">{errorEscenarios}</span>
                            :
                                escenariosEstrategicos.map((card:ICardHome,index:number) => {
                                    
                                
                                    return (
                                        <CardKPI
                                            key={index}
                                            id={card.id_plant}
                                            title={card.name_plant}
                                            id_plant={card.id_plant}
                                            kpi1title={card.kpis[0]?.kpi_label}
                                            kpi1={card.kpis[0]?.kpi_value}
                                            kpi2title={card.kpis[1]?.kpi_label}
                                            kpi2={card.kpis[1]?.kpi_value}
                                            anio={card.anio ?? 2024}
                                            cambio_pendiente={card.cambio_pendiente}
                                            handleOpenScenarioModal={handleOpenScenarioModal}
                                            type={"Estratégico"}
                                            
                                            />
                                    )
                                })
                    }
                </Fieldset>
                </div>
                <div>
                    <Fieldset legend={legendTemplateOp}>
                        {
                            loadingEscenarios?
                                <Spinner message={`Obteniendo Escenario Operativo`}/>
                            :
                                errorEscenarios !== ""?
                                    <span className="error__message">{errorEscenarios}</span>
                                :
                                    escenariosOperativos.map((card:ICardHome,index:number) => {
                                        return (
                                            <CardKPI
                                                key={index}
                                                id={card.id_scenario}
                                                title={card.name_plant}
                                                id_plant={card.id_plant}
                                                kpi1title={card.kpis[0]?.kpi_label}
                                                kpi1={card.kpis[0]?.kpi_value}
                                                kpi2title={card.kpis[1]?.kpi_label}
                                                kpi2={card.kpis[1]?.kpi_value}
                                                anio={card.anio ?? 2024}
                                                type={"Operativo"}
                                                />
                                        )
                                    })
                        }
                    </Fieldset>
                </div>
            </div>
            <div>
                <ScenarioModal
                    visible={openScenarioModal}
                    setVisible={setOpenScenarioModal}
                    selectedScenario={selectedScenario}
                    history={history}
                    scenarios={scenarios}
                    flag={flag}
                    setFlag={setFlag}
                    
                    />
            </div>
            
        </div>
    )
}